document.addEventListener("DOMContentLoaded", function() {
  try {
    // console.log('DOMContentLoaded event triggered');

    window.addEventListener("ss-on-results-load", () => {
      try {
        // console.log('ss-on-results-load event triggered');

        const collectionTabs = document.getElementById('collection-tabs');
        const searchspringContent = document.getElementById('searchspring-content');

        if (!searchspringContent) {
          console.error("searchspring-content element does not exist");
          return;
        }

        if (!collectionTabs) {
          // console.error("collection-tabs element does not exist");
        } else {
          searchspringContent.insertBefore(collectionTabs, searchspringContent.firstChild);
          collectionTabs.classList.remove('hidden');
        }

        // Add event listeners to active pagination links
        const paginationLinks = document.querySelectorAll('.ss__pagination__page a');

        // console.log('Pagination links found: ', paginationLinks.length);
        // console.log('Pagination links: ', paginationLinks)

        if (paginationLinks.length === 0) {
          console.warn("Pagination links not found yet. This may be normal during initial load.");
          return;
        }

        paginationLinks.forEach(link => {
          link.addEventListener('click', function(event) {
            try {
              // console.log('Pagination link clicked: ', link.href);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (error) {
              console.error("Error handling pagination link click: ", error);
            }
          });
        });

      } catch (error) {
        console.error("Error in ss-on-results-load event listener: ", error);
      }
    });

    // console.log('ss-on-results-load event listener added');
  } catch (error) {
    console.error("Error adding ss-on-results-load event listener: ", error);
  }
});
